import MatterNotesContainer from "@/components/features/matter/notes/MatterNotesContainer";
import { Card, CardContent, Typography } from "@/components/ui";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import { retrieveMassTortQueryOptions } from "@/lib/data/react-query/mass-torts/mass-tort";
import { getMassTortAnnotationMatter } from "@/lib/utils/massTortAnnotationUtils";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";

export const Route = createFileRoute(
  "/_auth/mass-torts/$massTortSearchId/_layout/notes",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { massTortSearchId: massTortId } = Route.useParams();

  const { data: massTortResponse, isLoading: isMassTortLoading } = useQuery({
    ...retrieveMassTortQueryOptions(massTortId),
  });

  const massTort = massTortResponse?.data;
  const annotationMatter = useMemo(
    () => getMassTortAnnotationMatter(massTort),
    [massTort],
  );
  const isPageLoading = Boolean(massTortId && isMassTortLoading);

  if (isPageLoading) {
    return <LawWorksLoader className="w-full" />;
  }

  if (!massTortId || !massTort) {
    return (
      <div className="grid h-screen w-full grid-cols-1 gap-4 p-6">
        <Card className="flex h-full flex-col">
          <CardContent className="flex h-full flex-col items-center justify-center gap-2 text-center">
            <Typography variant="subHeading">Mass tort notes</Typography>
            <Typography className="text-muted-foreground">
              Unable to load notes for this mass tort.
            </Typography>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <MatterNotesContainer
      notes={[]}
      matter={annotationMatter}
      massTortId={massTortId}
    />
  );
}
